<template>
  <div :class="`flex flex-col py-1 ${isMobile() ? 'w-full' : 'w-full' }`">

    <div :class="`flex w-full justify-between py-3 px-2 relative`">
      <div class="flex flex-col items-start">
        <!--  image with search icon code   -->
              <div class="flex items-center space-x-1">
                <WcTypography size="md" title="Recruiter GPT (Beta)" weight="600" />
                <WcIconPencilSparkle height="16" class="mr-2" color="#5138ee" />
              </div>
      </div>
      <div class="flex absolute w-full cursor-pointer justify-content-end pr-3" @click="handleDialogClose()">
        <WcIconCross height="17" width="16" color="black" />
      </div>
    </div>
    <!--   main chat div    -->
    <FullScreenLoading v-if="chatThreadHistoryLoading"  />
    <div v-if="!chatHistory.length && !chatThreadHistoryLoading" class="flex justify-center flex-grow space-y-6 flex-col">
      <div class="suggested-prompts mx-5 flex cursor-pointer" @click="sendSelectedPromptAsQuery(ind)" :key="ind" v-for="(prompt,ind) in suggestedPrompts">
        <div class="flex"><WcTypography size="sm" :title="prompt" weight="400" /></div>
        <div class="flex"><WcIconArrowLeftFull color="grey" class="flex transform rotate-180" /></div>
      </div>
    </div>
    <div v-if="chatHistory.length && !chatThreadHistoryLoading" :class="`flex ${isMobile() ? 'max-h-80' : ''} overflow-y-scroll flex-grow space-y-6 p-4 flex-col`" style="border-top: 2px solid #E9E9EC">
      <div :class="`flex space-x-2 ${msg.role === 'user' ? 'justify-end' : 'justify-start'} `" :key="msg.id+msg.role" v-for="(msg, ind) in chatHistory">
        <div v-if="msg.role === 'assistant'" class="image-style h-9 w-9 flex items-center justify-center">
          <img src="@/assets/icons/chatbot-search-icon.svg" alt="chatbot-search">
        </div>
        <div :class="`flex ${msg.role === 'user' ? 'justify-end' : 'w-full'}`">
          <div class="flex flex-col gap-1">
            <div :class="` ${msg.role === 'user' ? 'user-chat' : ' w-full'}`">
              <div  v-html="msg.role === 'user' ? msg.query : msg.answer !== 'true' ? msg.answer : ''" class="markdown-body"></div>
              <div class="flex flex-column space-y-2" v-if="msg.role === 'assistant' && msg.answer==='true'">
                <WcTypography size="sm" title="Hang tight! crafting your answer..." weight="500" />
                <LinesShimmer :lines="1" background-color="#fff" :show-avatar="false"/>
              </div>
            </div>
            <div :class="`flex gap-1 ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`">
              <div class="flex">
                <WcTypography size="xs" :title="formatTime(msg.createdAt)" weight="400" color="rgba(4, 4, 16, 0.6)" />
              </div>
              <div @click="submitFeedback(msg.id, 'like', ind)" v-if="(msg.role==='assistant' && msg.answer!=='true')" class="flex cursor-pointer">
                <WcIconLike :color="msg.query ==='like' ? 'gray' : 'none'" />
              </div>
              <div @click="submitFeedback(msg.id, 'dislike', ind)" v-if="(msg.role==='assistant' && msg.answer!=='true')" class="flex cursor-pointer">
                <WcIconUnlike :color="msg.query ==='dislike' ? 'gray' : 'none'" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="msg.role === 'user'" class="flex">
          <!--  bot icon        -->
          <ColoredAlphabetIcon :text="UserModule().firstName"/>
        </div>
      </div>
      <div id="moveToChatEndDiv">
      </div>
    </div>
    <div class="flex mb-4">
      <div class="flex flex-col w-full p-3" >
        <div class="flex px-1 relative w-full">
          <ElInput @change="sendQueryIfUserClickedEnter($event)" v-model="inputQuery" placeholder="Ask Recruiter GPT" class="w-full  flex-grow ml-2"  />
          <span @click="sendInputQuery">
            <WcIconSend size="md" :fill-opacity="inputQuery ? '' : '0.6'" class="absolute right-0 bottom-0 mr-3 mb-3 cursor-pointer" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import WcIconExternalLink from '@/components/UILibrary/Icons/WcIconExternalLink.vue'
import WcIconWhatsApp from '@/components/UILibrary/Icons/WcIconWhatsApp.vue'
import WcIconFeedback from '@/components/UILibrary/Icons/WcIconFeedback.vue'
import WcIconArrowLeftFull from '@/components/UILibrary/Icons/WcIconArrowLeftFull.vue'
import WcIconSend from '@/components/UILibrary/Icons/WcIconSend.vue'
import LoadingAnimation from '@/components/UILibrary/loading-animation.vue'
import WcIconCross from '@/components/UILibrary/Icons/WcIconCross.vue'
import FullScreenLoading from '@/components/UILibrary/full-screen-loading.vue'
import { formatDate } from '@/utils/date'
import WcIconLike from '@/components/UILibrary/Icons/WcIconLike.vue'
import WcIconUnlike from '@/components/UILibrary/Icons/WcIconUnlike.vue'
import ColoredAlphabetIcon from '@/components/UILibrary/Icons/ColoredAlphabetIcon.vue'
import { UserModule } from '@/store/modules/user'
import { isMobile } from '@/utils/general'
import WcIconHamburger from '@/components/UILibrary/Icons/WcIconHamburger.vue'
import LinesShimmer from '@/components/UILibrary/Shimmers/LinesShimmer.vue'
import WcIconPencilSparkle from '@/components/UILibrary/Icons/WcIconPencilSparkle.vue'

@Component({
  name: 'ChatThreadSection',
  methods: {
    isMobile,
    UserModule() {
      return UserModule
    }
  },
  components: {
    WcIconPencilSparkle,
    LinesShimmer,
    WcIconHamburger,
    ColoredAlphabetIcon,
    WcIconUnlike,
    WcIconLike,
    FullScreenLoading,
    WcIconCross,
    LoadingAnimation,
    WcIconSend,
    WcIconArrowLeftFull,
    WcIconFeedback,
    WcIconWhatsApp,
    WcIconExternalLink,
    WcTypography
  }
})
export default class extends Vue {
  @Prop({ required: true, type: Function }) handleDialogClose!: Function;
  @Prop({ required: true, type: Function }) sendQuery!: Function;
  @Prop({ required: true, type: Function }) submitFeedback!: Function;
  @Prop({ required: true, type: Function }) sendSelectedPromptAsQuery!: Function;
  @Prop({ required: true }) suggestedPrompts!: string[]
  @Prop({ required: true }) chatHistory!: {
  id: string // messageId
  conversationId: string
  query: string
  answer: string
  createdAt: string
  role: string
}[]

  @Prop({ required: true }) currentThreadId!: string
  @Prop({ required: true }) userQuery!: string
  @Prop({ required: true }) chatThreadHistoryLoading!: boolean

  inputQuery = '';

  sendInputQuery() {
    const data = this.inputQuery
    this.inputQuery = ''
    this.$emit('input', data)
  }

  sendQueryIfUserClickedEnter(event: Event) {
    this.inputQuery = ''
    this.$emit('input', event)
  }

  formatTime(timestamp: string) {
    // Create a Date object from the timestamp (converted to milliseconds)
    let date = new Date()
    if (timestamp !== 'Now') {
      date = new Date(parseInt(timestamp) * 1000)
    }

    // Format the time as a string in local time
    return formatDate(date, 'MMM DD, YYYY h:mm A')
  }
}
</script>
<style scoped>
.image-style{
  border-radius: 2rem;
  background: #EFF5FF;
}

::v-deep .el-input__inner {
  height: 50px !important;
  border: 1px solid #5138EE !important;
}

::v-deep .el-input__inner::placeholder {
  color: rgba(4, 4, 16, 0.87) !important;
}

.suggested-prompts{
  /* Text field */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  gap: 10px;

  border: 1px solid #E9E9EC;
  border-radius: 10px;

}

.user-chat{

  /* Auto layout */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px 16px;
  gap: 10px;

  background: #F0F4FB;
  border-radius: 10px;
  /* Prevent shrinking smaller than content */
  flex-shrink: 0;

  /* Allow growing to fit content */
  flex-grow: 1;
  word-wrap: break-word;

}

.assistant-chat{
  /* Text field */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  gap: 10px;

  background: #EFEFF1;
  border-radius: 10px;

  /* Prevent shrinking smaller than content */
  flex-shrink: 0;

  /* Allow growing to fit content */
  flex-grow: 1;
  word-wrap: break-word;
}

::v-deep a {
  color: #0056b3; /* A shade of blue typical for links */
  text-decoration: underline; /* Underline to highlight links */
  cursor: pointer; /* Shows a pointer cursor on hover to indicate clickability */
}

::v-deep a:hover {
  color: #003580; /* A darker blue for hover effect */
}
@mixin light {
  color-scheme: light;
  --color-prettylights-syntax-comment: #6e7781;
  --color-prettylights-syntax-constant: #0550ae;
  --color-prettylights-syntax-entity: #8250df;
  --color-prettylights-syntax-storage-modifier-import: #24292f;
  --color-prettylights-syntax-entity-tag: #116329;
  --color-prettylights-syntax-keyword: #cf222e;
  --color-prettylights-syntax-string: #0a3069;
  --color-prettylights-syntax-variable: #953800;
  --color-prettylights-syntax-brackethighlighter-unmatched: #82071e;
  --color-prettylights-syntax-invalid-illegal-text: #f6f8fa;
  --color-prettylights-syntax-invalid-illegal-bg: #82071e;
  --color-prettylights-syntax-carriage-return-text: #f6f8fa;
  --color-prettylights-syntax-carriage-return-bg: #cf222e;
  --color-prettylights-syntax-string-regexp: #116329;
  --color-prettylights-syntax-markup-list: #3b2300;
  --color-prettylights-syntax-markup-heading: #0550ae;
  --color-prettylights-syntax-markup-italic: #24292f;
  --color-prettylights-syntax-markup-bold: #24292f;
  --color-prettylights-syntax-markup-deleted-text: #82071e;
  --color-prettylights-syntax-markup-deleted-bg: #ffebe9;
  --color-prettylights-syntax-markup-inserted-text: #116329;
  --color-prettylights-syntax-markup-inserted-bg: #dafbe1;
  --color-prettylights-syntax-markup-changed-text: #953800;
  --color-prettylights-syntax-markup-changed-bg: #ffd8b5;
  --color-prettylights-syntax-markup-ignored-text: #eaeef2;
  --color-prettylights-syntax-markup-ignored-bg: #0550ae;
  --color-prettylights-syntax-meta-diff-range: #8250df;
  --color-prettylights-syntax-brackethighlighter-angle: #57606a;
  --color-prettylights-syntax-sublimelinter-gutter-mark: #8c959f;
  --color-prettylights-syntax-constant-other-reference-link: #0a3069;
  --color-fg-default: #24292f;
  --color-fg-muted: #57606a;
  --color-fg-subtle: #6e7781;
  --color-canvas-default: transparent;
  --color-canvas-subtle: #f6f8fa;
  --color-border-default: #d0d7de;
  --color-border-muted: hsla(210, 18%, 87%, 1);
  --color-neutral-muted: rgba(175, 184, 193, 0.2);
  --color-accent-fg: #0969da;
  --color-accent-emphasis: #0969da;
  --color-attention-subtle: #fff8c5;
  --color-danger-fg: #cf222e;
}

::v-deep .markdown-body {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  margin: 0;
  color: #101828;
  background-color: var(--color-canvas-default);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  word-wrap: break-word;
}

.light {
  @include light;
}

:root {
  @include light;
}

@media (prefers-color-scheme: light) {
  :root {
    @include light;
  }
}

::v-deep .markdown-body summary {
  display: list-item;
}

::v-deep .markdown-body [hidden] {
  display: none !important;
}

::v-deep .markdown-body a {
  color: #0969da !important;
  text-decoration: none;
}

::v-deep .markdown-body abbr[title] {
  border-bottom: none;
  text-decoration: underline dotted;
}

::v-deep .markdown-body b,
.markdown-body strong {
  font-weight: 600;
}

::v-deep .markdown-body small {
  font-size: 90%;
}

::v-deep .markdown-body sub,
.markdown-body sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

::v-deep .markdown-body sub {
  bottom: -0.25em;
}

::v-deep .markdown-body sup {
  top: -0.5em;
}

::v-deep .markdown-body a:hover {
  text-decoration: underline;
}

::v-deep .markdown-body hr::before {
  display: table;
  content: "";
}

::v-deep .markdown-body hr::after {
  display: table;
  clear: both;
  content: "";
}

::v-deep .markdown-body details:not([open])>*:not(summary) {
  display: none !important;
}

::v-deep .markdown-body a:focus {
  outline: 2px solid var(--color-accent-fg);
  outline-offset: -2px;
  box-shadow: none;
}

::v-deep .markdown-body a:focus:not(:focus-visible) {
  outline: solid 1px transparent;
}

::v-deep .markdown-body a:focus-visible {
  outline: 2px solid var(--color-accent-fg);
  outline-offset: -2px;
  box-shadow: none;
}

::v-deep .markdown-body a:not([class]):focus,
.markdown-body a:not([class]):focus-visible {
  outline-offset: 0;
}

::v-deep .markdown-body h1,
.markdown-body h2,
.markdown-body h3,
.markdown-body h4,
.markdown-body h5,
.markdown-body h6 {
  margin-top: 24px;
  margin-bottom: 1rem;
  font-weight: 600;
  line-height: 1.25;
}

::v-deep .markdown-body p {
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .markdown-body blockquote {
  margin: 0;
  padding: 0 8px;
  border-left: 2px solid #2970FF;
}

::v-deep .markdown-body ol{
  list-style: disc;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
}

::v-deep .markdown-body ul {
  list-style: disc;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
}

::v-deep .markdown-body ol ol,
.markdown-body ul ol {
  list-style-type: lower-roman;
}

::v-deep .markdown-body pre {
  margin-top: 0;
  margin-bottom: 0;
  font-family: ui-monospace, SFMono-Regular, SF Mono, Menlo, Consolas,
  Liberation Mono, monospace;
  font-size: 12px;
  word-wrap: normal;
}
::v-deep .markdown-body::before {
  display: table;
  content: "";
}

::v-deep .markdown-body::after {
  display: table;
  clear: both;
  content: "";
}

::v-deep .markdown-body>*:first-child {
  margin-top: 0 !important;
}

::v-deep .markdown-body>*:last-child {
  margin-bottom: 0 !important;
}

::v-deep .markdown-body a:not([href]) {
  color: inherit;
  text-decoration: none;
}

::v-deep .markdown-body .absent {
  color: var(--color-danger-fg);
}

::v-deep .markdown-body .anchor {
  float: left;
  padding-right: 4px;
  margin-left: -20px;
  color: #0000FF;
  line-height: 1;
}

::v-deep .markdown-body .anchor:focus {
  outline: none;
}

::v-deep .markdown-body p,
.markdown-body blockquote,
.markdown-body ul,
.markdown-body ol,
.markdown-body dl,
.markdown-body table,
.markdown-body pre,
.markdown-body details {
  margin-top: 0;
  margin-bottom: 16px;
}

::v-deep .markdown-body blockquote> :first-child {
  margin-top: 0;
}

::v-deep .markdown-body blockquote> :last-child {
  margin-bottom: 0;
}

::v-deep .markdown-body h1:hover .anchor,
.markdown-body h2:hover .anchor,
.markdown-body h3:hover .anchor,
.markdown-body h4:hover .anchor,
.markdown-body h5:hover .anchor,
.markdown-body h6:hover .anchor {
  text-decoration: none;
}

::v-deep .markdown-body ul.no-list,
.markdown-body ol.no-list {
  padding: 0;
  list-style-type: none;
}

::v-deep .markdown-body ol[type="a"] {
  list-style-type: lower-alpha;
}

::v-deep .markdown-body ol[type="A"] {
  list-style-type: upper-alpha;
}

::v-deep .markdown-body ol[type="i"] {
  list-style-type: lower-roman;
}

::v-deep .markdown-body ol[type="I"] {
  list-style-type: upper-roman;
}

::v-deep .markdown-body ol[type="1"] {
  list-style-type: decimal;
}

::v-deep .markdown-body div>ol:not([type]) {
  list-style-type: decimal;
}

::v-deep .markdown-body ul ul,
.markdown-body ul ol,
.markdown-body ol ol,
.markdown-body ol ul {
  margin-top: 0;
  margin-bottom: 0;
}

::v-deep .markdown-body li>p {
  margin-top: 16px;
}

::v-deep .markdown-body li+li {
  margin-top: 0.25em;
}

::v-deep .markdown-body span.frame {
  display: block;
  overflow: hidden;
}

::v-deep .markdown-body span.frame>span {
  display: block;
  float: left;
  width: auto;
  padding: 7px;
  margin: 13px 0 0;
  overflow: hidden;
  border: 1px solid var(--color-border-default);
}

::v-deep .markdown-body span.frame span img {
  display: block;
  float: left;
}

::v-deep .markdown-body span.frame span span {
  display: block;
  padding: 5px 0 0;
  clear: both;
  color: var(--color-fg-default);
}

::v-deep .markdown-body span.align-center {
  display: block;
  overflow: hidden;
  clear: both;
}

::v-deep .markdown-body span.align-center>span {
  display: block;
  margin: 13px auto 0;
  overflow: hidden;
  text-align: center;
}

::v-deep .markdown-body span.align-center span img {
  margin: 0 auto;
  text-align: center;
}

::v-deep .markdown-body span.align-right {
  display: block;
  overflow: hidden;
  clear: both;
}

::v-deep .markdown-body span.align-right>span {
  display: block;
  margin: 13px 0 0;
  overflow: hidden;
  text-align: right;
}
::v-deep .markdown-body span.float-left {
  display: block;
  float: left;
  margin-right: 13px;
  overflow: hidden;
}

::v-deep .markdown-body span.float-left span {
  margin: 13px 0 0;
}

::v-deep .markdown-body span.float-right {
  display: block;
  float: right;
  margin-left: 13px;
  overflow: hidden;
}

::v-deep .markdown-body span.float-right>span {
  display: block;
  margin: 13px auto 0;
  overflow: hidden;
  text-align: right;
}
</style>
